import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  TablePagination,
  IconButton,
  Collapse,
  Typography,
  Tooltip,
} from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { ToastContainer } from "react-toastify";
import DatePicker from "antd/es/date-picker";
import dayjs from "dayjs";
import PulseLoader from "react-spinners/PulseLoader";
import Sidebar from "./Sidebar";
import { get } from "../library/Api";

function Row({ log, index }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Main Row */}
      <TableRow
        style={{
          backgroundColor: index % 2 === 0 ? "#f5faff" : "white",
        }}
      >
        <TableCell />
        <TableCell>
          {Array.isArray(log.entry_names) && log.entry_names.length > 0 ? (
            <>
              {log.entry_names.slice(0, 2).map((entry, idx) => (
                <span key={idx} style={{ marginRight: 6 }}>
                  {idx > 0 ? `, ${entry}` : entry}
                </span>
              ))}

              {/* {log.entry_names.length > 2 && (
                <Tooltip
                  title={log.entry_names.slice(2).join(", ")}
                  arrow
                  placement="top"
                >
                  <span style={{ color: "#02487B", cursor: "pointer" }}>
                    +{log.entry_names.length - 2}
                  </span>
                </Tooltip>
              )} */}
              {log.entry_names.length > 2 && (
                <Tooltip
                  // title={log.entry_names.slice(2).join(", ")}
                  title={
                    <div
                      style={{
                        whiteSpace: "pre-line",
                        fontSize: "14px",
                        color: "black",
                         maxHeight: "500px",  
                         overflowY: "auto", 
                      }}
                    >
                      {log.entry_names.slice(2).join("\n")}{" "}
                      {/* each on new line */}
                    </div>
                  }
                  arrow
                  placement="bottom"
                  slotProps={{
                    popper: {
                      modifiers: [
                        {
                          name: "flip",
                          options: {
                            fallbackPlacements: ["bottom"], 
                          },
                        },
                        {
                          name: "preventOverflow",
                          options: {
                            boundary: "viewport", 
                          },
                        },
                      ],
                    },
                    tooltip: {
                      sx: {
                        backgroundColor: "white", 
                        border: "1px solid #ddd", 
                        borderRadius: "12px",
                        boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
                      },
                    },
                  }}
                >
                  <span
                    style={{
                      backgroundColor: "#e3f3fd",
                      color: "black",
                      border: "1px solid #A5C4E6",
                      borderRadius: "10px",
                      padding: "2px 8px",
                      fontSize: "12px",
                      fontWeight: "normal",
                      cursor: "pointer",
                      display: "inline-block",
                      minWidth: "20px",
                      textAlign: "center",
                    }}
                  >
                    +{log.entry_names.length - 2} more
                  </span>
                </Tooltip>
              )}
            </>
          ) : (
            "-"
          )}
        </TableCell>
        <TableCell>{log.visitor_name}</TableCell>
        <TableCell>{log.visitor_email}</TableCell>
        <TableCell>{log.user_email}</TableCell>
        <TableCell>
          {log.access_start
            ? dayjs(log.access_start).format("MMM DD, YYYY")
            : "-"}
        </TableCell>
        <TableCell>
          {log.access_end ? dayjs(log.access_end).format("MMM DD, YYYY") : "-"}
        </TableCell>
        <TableCell>
          {log.link_active ? (
            <span
              style={{
                display: "inline-block",
                padding: "4px 10px",
                borderRadius: "12px",
                border: `2px solid ${
                  log.link_active.toLowerCase() === "active" ? "green" : "brown"
                }`,
                color:
                  log.link_active.toLowerCase() === "active"
                    ? "green"
                    : "brown",
                fontWeight: "bold",
                textTransform: "capitalize",
              }}
            >
              {log.link_active}
            </span>
          ) : (
            "-"
          )}
        </TableCell>
      </TableRow>

      {/* Sub-row (collapsible entry names) */}
      {Array.isArray(log.entry_names) && log.entry_names.length > 1 && (
        <TableRow>
          <TableCell colSpan={8} style={{ paddingBottom: 0, paddingTop: 0 }}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1}>
                {/* <Typography sx={{ pl: 8 }} >Entry Names</Typography> */}
                <Table size="small">
                  <TableBody>
                    {log.entry_names.map((entry, idx) => (
                      <TableRow key={idx}>
                        <TableCell sx={{ pl: 10 }}>{entry}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </>
  );
}

export default function VisitorsLog() {
  const [customerdata, setCustomerData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [dateFilterData, setDateFilterData] = useState(null);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = () => {
    setIsLoading(true);
    get(`getvisitorlogs`)
      .then((res) => {
        const data = res.data;
        if (data.logs) {
          setCustomerData(data.logs);
        }
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  };

  const onChange = (e) => {
    setFirstName(e.target.value);
  };

  const dateFilter = (date) => {
    setDateFilterData(date ? date.format("YYYY-MM-DD") : null);
  };

  const filteredData = customerdata.filter((log) => {
    const searchTerm = firstName.toLowerCase();
    const nameMatch =
      log.visitor_name?.toLowerCase().includes(searchTerm) ||
      log.visitor_company?.toLowerCase().includes(searchTerm) ||
      log.entry_name?.toLowerCase().includes(searchTerm);

    const dateMatch = dateFilterData
      ? dayjs(log.access_start).isSame(dayjs(dateFilterData), "day") ||
        dayjs(log.access_end).isSame(dayjs(dateFilterData), "day")
      : true;

    return nameMatch && dateMatch;
  });

  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <React.Fragment>
      <ToastContainer />
      <Box sx={{ display: "flex" }}>
        <Sidebar />
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          <h3 className="heading-style">Visitors Log</h3>

          <div
            style={{
              background: "#fff",
              padding: "12px 10px",
              borderRadius: "15px",
            }}
          >
            {isLoading ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "50vh",
                }}
              >
                <PulseLoader color="#02487B" size={15} />
                <p
                  style={{
                    fontWeight: "bold",
                    color: "#02487B",
                    marginTop: "10px",
                  }}
                >
                  Loading
                </p>
              </div>
            ) : filteredData.length > 0 ? (
              <TableContainer component={Paper}>
                <Table aria-label="Customer Details Table">
                  <TableHead>
                    <TableRow>
                      <TableCell className="bg-table-blue_head" />
                      <TableCell className="bg-table-blue_head">
                        <strong>Entry Name</strong>
                      </TableCell>
                      <TableCell className="bg-table-blue_head">
                        <strong>Visitor Name</strong>
                      </TableCell>
                      <TableCell className="bg-table-blue_head">
                        <strong>Visitor Email</strong>
                      </TableCell>
                      <TableCell className="bg-table-blue_head">
                        <strong>User Email</strong>
                      </TableCell>
                      <TableCell className="bg-table-blue_head">
                        <strong>Created Date</strong>
                      </TableCell>
                      <TableCell className="bg-table-blue_head">
                        <strong>Expired Date</strong>
                      </TableCell>
                      <TableCell className="bg-table-blue_head">
                        <strong>Status</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedData.map((log, index) => (
                      <Row key={log.visitoraccess_id} log={log} index={index} />
                    ))}
                  </TableBody>
                </Table>

                <TablePagination
                  sx={{
                    // "& .MuiTablePagination-toolbar": {
                    //   alignItems: "flex-end", // moves both label & dropdown down
                    // },
                    "& .MuiTablePagination-selectLabel": {
                      paddingTop: "8px", // specifically move "Records per page" text down
                    },
                    "& .MuiTablePagination-displayedRows": {
                      paddingTop: "8px", // also move the "1–10 out of X" down
                    },
                  }}
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  component="div"
                  count={filteredData.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={(event, newPage) => setPage(newPage)}
                  onRowsPerPageChange={(event) => {
                    setRowsPerPage(parseInt(event.target.value, 10));
                    setPage(0);
                  }}
                  labelRowsPerPage="Records per page:"
                  labelDisplayedRows={({ from, to, count }) =>
                    `${from}–${to} out of ${count}`
                  }
                />
              </TableContainer>
            ) : (
              <div
                style={{
                  textAlign: "center",
                  padding: "20px",
                  fontWeight: "bold",
                  color: "#666",
                }}
              >
                No Visitor Logs
              </div>
            )}
          </div>
        </Box>
      </Box>
    </React.Fragment>
  );
}
